export const DESTINATION_STAFF_TEAM_ID = 4;


// WEBPACK FOOTER //
// ./src/containers/staff/constants.js